import { useState, useRef, useEffect, forwardRef } from "react";
// import moment from "moment-timezone";
import { InputAdornment, TextField } from "@mui/material";

const MS_PER_MINUTE = 60000;

const EditableCellNumber = forwardRef(
  ({ label, amount, setAmount, onKeyDown, onValidate, adornmentSymbol, disabled }, ref) => {
    const [displayAmount, setDisplayAmount] = useState(amount);

    useEffect(() => {
      setDisplayAmount(amount);
    }, [amount]);

    const cleanInput = (value) => {
      // Remove any character that's not a digit or decimal point
      let cleaned = value.replace(/[^\d.]/g, "");

      // Ensure only one decimal point
      const parts = cleaned.split(".");
      if (parts.length > 2) {
        // eslint-disable-next-line prefer-template
        cleaned = parts[0] + "." + parts.slice(1).join("");
      }

      return cleaned;
    };

    const handleBlur = (e) => {
      const am = cleanInput(e.target.value);
      if (onValidate) {
        const valid = onValidate(am);
        if (!valid) {
          setDisplayAmount(amount);
          return;
        }
      }
      setAmount(am);
      setDisplayAmount(am);
    };

    return (
      <>
        <TextField
          id="edit-money-basic"
          label={label}
          variant="outlined"
          inputRef={ref}
          value={displayAmount}
          onChange={(e) => setDisplayAmount(cleanInput(e.target.value))}
          onBlur={handleBlur}
          InputProps={
            adornmentSymbol
              ? {
                  startAdornment: (
                    <InputAdornment position="start">{adornmentSymbol}</InputAdornment>
                  ),
                }
              : undefined
          }
          onKeyDown={onKeyDown}
          // eslint-disable-next-line react/jsx-no-duplicate-props
          inputProps={{
            autoComplete: "off",
            autoCorrect: "off",
            autoCapitalize: "off",
            spellCheck: false,
          }}
          disabled={disabled}
          sx={{ width: "100%" }}
        />
      </>
    );
  }
);

export default EditableCellNumber;
